import { OpenTabSummaryDto, PosTabType } from '@klubovna/api-client';

export function getTabDisplayName(tab: OpenTabSummaryDto): string {
  if (tab.type === PosTabType.User && tab.userName) {
    return tab.userName;
  } else if (tab.type === PosTabType.Visitor && tab.visitorAlias) {
    return tab.visitorAlias;
  }
  return `Tab #${ tab.id.slice(0, 8) }`;
}
